import React, { Component } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { SideBar, NavBar, Footer, TitleAndDescription } from "../../components";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Button,
  UncontrolledTooltip,
} from "reactstrap";
import DropFileInput from "./DropFileInput";
import DatePicker from "react-datepicker";
import moment from "moment";
import queryString from "query-string";
const { formatarReal } = require("../../utils");

class Roteirizador extends Component {
  constructor(props) {
    super(props);
    this.load = this.load.bind(this);
    this.loadDespesas = this.loadDespesas.bind(this);
    this.toggle = this.toggle.bind(this);
    this.handleClickDeletar = this.handleClickDeletar.bind(this);
    this.handleClickConfirmaDeletar =
      this.handleClickConfirmaDeletar.bind(this);
    this.felipe = this.felipe.bind(this);
    this.loadCallbackRoteirizador = this.loadCallbackRoteirizador.bind(this);
    this.onClickVisualizarDanfe = this.onClickVisualizarDanfe.bind(this);
    this.getLetraAlfabeto = this.getLetraAlfabeto.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.loadVeiculos = this.loadVeiculos.bind(this);
    this.loadMotoristas = this.loadMotoristas.bind(this);
    this.toggle2 = this.toggle2.bind(this);
    this.handleClickSalvarRoteiro = this.handleClickSalvarRoteiro.bind(this);
    this.handleChangeNomeRoteiro = this.handleChangeNomeRoteiro.bind(this);
    this.handleChangeCobrar = this.handleChangeCobrar.bind(this);
    this.loadSequenciaRoteiro = this.loadSequenciaRoteiro.bind(this);
    this.atualizaSequenciaRoteiro = this.atualizaSequenciaRoteiro.bind(this);
    this.toggleModalXml = this.toggleModalXml.bind(this);
    this.loadXmlsBanco = this.loadXmlsBanco.bind(this);
    this.handleClickCheckbox = this.handleClickCheckbox.bind(this);
    this.handleClickImportarXml = this.handleClickImportarXml.bind(this);
    this.loadXmlsTemplateRoteiro = this.loadXmlsTemplateRoteiro.bind(this);
    this.handleSalvarTemplate = this.handleSalvarTemplate.bind(this);
    this.handleChangeNomeTemplate = this.handleChangeNomeTemplate.bind(this);
    this.toggle3 = this.toggle3.bind(this);

    this.iframeRef = React.createRef();

    this.state = {
      despesas: [],
      despesaDeletar: null,
      modal: false,
      totalizadores: {
        saldoMensal: 0,
        pagos: 0,
        pendentes: 0,
      },
      lista: [],
      listaXml: [],
      idXmlDeletar: null,

      files: [],
      xmlStrings: [],
      veiculos: [],
      veiculoSelecionado: null,
      motoristas: [],
      motoristaSelecionado: null,
      data: new Date(),
      modal2: false,
      nomeRoteiro: "",
      codigo: "0000",
      modalXml: false,
      xmlsBanco: [],
      descTemplate: "",
      idTemplate: null,
      descTemplateNovo: "",
      modal3: false,
    };
  }

  async componentDidMount() {

    // alert('aaa')


    // KRAUSE
    // await axios
    //   .post(
    //     `${this.props.getBaseUrlRoteirizador()}/limpar-rotas`,
    //     {},
    //     this.props.parameters()
    //   )
    //   .then((response) => {});

    let idTemplate = queryString.parse(this.props.location.search).idtemplate;

    if (idTemplate !== undefined) {
      this.loadXmlsTemplateRoteiro(idTemplate);
    }

    await this.load();
    await this.loadCallbackRoteirizador();
    await this.loadSequenciaRoteiro();
    await this.loadXmlsBanco();
  }

  async loadCallbackRoteirizador() {
    window.addEventListener("message", (event) => {
      if (event.origin === this.props.getBaseUrlRoteirizador()) {
        //console.log(event.data);
        let data = JSON.parse(event.data);
        let lista = [];

        let waypointsOrder = data.routes[0].waypoint_order;

        let primeiroItem = data.request.origin.query;

        let itemPush2 = {
          _id: Math.random().toString().split(".")[1],
          endereco: primeiroItem,
          distancia: null,
          duracao: null,
          enderecoPartida: null,
          cliente: "",
          telefone: "",
          xml: null,
          exibirCobrar: false,
          coordenadas: null,
          enderecoCompleto: null,
        };

        lista.push(itemPush2);

        //return false;

        for (let i = 0; i < data.routes[0].legs.length; i++) {
          let item = data.routes[0].legs[i];
          console.log(item.end_address);

          let itemPush = {
            _id: Math.random().toString().split(".")[1],
            endereco: item.end_address,
            distancia: item.distance.text,
            duracao: item.duration.text,
            enderecoPartida: item.start_address,
            cliente: "",
            telefone: "",
            xml: null,
            exibirCobrar: false,
            cobrar: true,
            coordenadas: item.end_location,
          };

          console.log("lalalalalal", itemPush);

          if (this.state.listaXml.length > 0) {
            // if (i !== data.routes[0].legs.length - 1) {
            // if (i !== data.routes[0].legs.length) {
            let indexLista = waypointsOrder[i];
            let listaXml = this.state.listaXml;

            let itemXml = listaXml[indexLista];

            if (itemXml !== undefined) {
              let teste22 = Object.assign({}, itemXml);
              delete teste22.xml;

              console.log("lkjh", JSON.stringify(teste22));

              //return false;

              itemPush.cliente = itemXml.nome;
              itemPush.cnpj = itemXml.cnpj;
              itemPush.telefone = itemXml.telefone;
              itemPush.xml = itemXml.xml;
              itemPush.exibirCobrar = true;
              itemPush.enderecoCompleto = itemXml.enderecoCompleto;
              itemPush.produtos = itemXml.produtos;
              itemPush.dadosNota = itemXml.dadosNota;
            }
            //}
          }

          lista.push(itemPush);
        }

        // lista.pop();

        this.setState({ lista }, () => {
          console.log("ggggggggggggggggggggggggggg", lista);
        });

        ///console.log(lista);
      }
    });
  }

  async load() {
    await this.loadVeiculos();
    await this.loadMotoristas();
  }

  async loadDespesas() {
    await axios
      .get(
        `${this.props.getBaseUrlApi()}/retaguarda/despesas`,
        this.props.parameters()
      )
      .then((response) => {
        let totalizadores = response.data.totalizadoresMensal;

        this.setState({
          despesas: response.data.usuarios,
          totalizadores: {
            saldoMensal: totalizadores.saldo,
            pagos: totalizadores.pagos,
            pendentes: totalizadores.pendentes,
          },
        });
      });
  }

  async felipe(listaXmlPreDefinidas = null) {
    const xml2 = `<?xml version="1.0" encoding="UTF-8"?><nfeProc xmlns="http://www.portalfiscal.inf.br/nfe" versao="4.00"><NFe xmlns="http://www.portalfiscal.inf.br/nfe"><infNFe Id="NFe42230485070068001090550020000320811571552860" versao="4.00"><ide><cUF>42</cUF><cNF>57155286</cNF><natOp>VDA MERC ADQ TERC</natOp><mod>55</mod><serie>2</serie><nNF>32081</nNF><dhEmi>2023-04-20T04:15:00-03:00</dhEmi><dhSaiEnt>2023-04-20T04:15:00-03:00</dhSaiEnt><tpNF>1</tpNF><idDest>1</idDest><cMunFG>4208203</cMunFG><tpImp>1</tpImp><tpEmis>1</tpEmis><cDV>0</cDV><tpAmb>1</tpAmb><finNFe>1</finNFe><indFinal>1</indFinal><indPres>0</indPres><procEmi>0</procEmi><verProc>12.1.033 | 3.0</verProc></ide><emit><CNPJ>85070068001090</CNPJ><xNome>Goncalves e Tortola SA - (FL 01016)</xNome><xFant>GTFOODS ITAJAI FILIAL DE VENDA</xFant><enderEmit><xLgr>Rodovia Jorge Lacerda</xLgr><nro>SN</nro><xBairro>Salseiros</xBairro><cMun>4208203</cMun><xMun>ITAJAI</xMun><UF>SC</UF><CEP>88311605</CEP><cPais>1058</cPais><xPais>BRASIL</xPais></enderEmit><IE>255383533</IE><CRT>3</CRT></emit><dest><CNPJ>09402073000184</CNPJ><xNome>PATRICIO DUMKE LATICINIOS</xNome><enderDest><xLgr>RUA ALFREDO SCHULZE</xLgr><nro>234</nro><xBairro>PIRABEIRABA</xBairro><cMun>4209102</cMun><xMun>JOINVILLE</xMun><UF>SC</UF><CEP>89239210</CEP><cPais>1058</cPais><xPais>BRASIL</xPais><fone>47992662087</fone></enderDest><indIEDest>1</indIEDest><IE>255570597</IE><email>DUMKEALIMENTOS@HOTMAIL.COM;faturamento@alinetto.com.br</email></dest><det nItem="1"><prod><cProd>FRCSMIFMI000001</cProd><cEAN>7897200602188</cEAN><xProd>CORTES CONGELADOS DE FRANGO (COXA E SOBRECOXA INDIVID) CX PP 18 KG MISTER FRANGO</xProd><NCM>02071400</NCM><CEST>1708700</CEST><cBenef></cBenef><CFOP>5102</CFOP><uCom>KG</uCom><qCom>90.0000</qCom><vUnCom>6.95000000</vUnCom><vProd>625.50</vProd><cEANTrib>17897200602185</cEANTrib><uTrib>KG</uTrib><qTrib>90.0000</qTrib><vUnTrib>6.95000000</vUnTrib><indTot>1</indTot></prod><imposto><ICMS><ICMS20><orig>0</orig><CST>20</CST><modBC>3</modBC><pRedBC>41.6700</pRedBC><vBC>364.85</vBC><pICMS>12.0000</pICMS><vICMS>43.78</vICMS><vICMSDeson>31.28</vICMSDeson><motDesICMS>9</motDesICMS></ICMS20></ICMS><IPI><cEnq>999</cEnq><IPINT><CST>51</CST></IPINT></IPI><PIS><PISNT><CST>06</CST></PISNT></PIS><COFINS><COFINSNT><CST>06</CST></COFINSNT></COFINS></imposto><infAdProd>Valor Dispensado R$ 31.28, Motivo da Desoneracao do ICMS: 9.(Ajuste SINIEF 25/12, efeitos a partir de 20.12.12)</infAdProd></det><det nItem="2"><prod><cProd>FRMDCANMI000015</cProd><cEAN>7898208480235</cEAN><xProd>MIUDOS CONGELADOS DE FRANGO (CORACAO) CX PP 20 KG (CANCAO)</xProd><NCM>02071400</NCM><CEST>1708700</CEST><cBenef></cBenef><CFOP>5102</CFOP><uCom>KG</uCom><qCom>40.0000</qCom><vUnCom>19.59000000</vUnCom><vProd>783.60</vProd><cEANTrib>27898208480239</cEANTrib><uTrib>KG</uTrib><qTrib>40.0000</qTrib><vUnTrib>19.59000000</vUnTrib><indTot>1</indTot></prod><imposto><ICMS><ICMS20><orig>0</orig><CST>20</CST><modBC>3</modBC><pRedBC>41.6700</pRedBC><vBC>457.08</vBC><pICMS>12.0000</pICMS><vICMS>54.85</vICMS><vICMSDeson>39.18</vICMSDeson><motDesICMS>9</motDesICMS></ICMS20></ICMS><IPI><cEnq>999</cEnq><IPINT><CST>51</CST></IPINT></IPI><PIS><PISNT><CST>06</CST></PISNT></PIS><COFINS><COFINSNT><CST>06</CST></COFINSNT></COFINS></imposto><infAdProd>Valor Dispensado R$ 39.18, Motivo da Desoneracao do ICMS: 9.(Ajuste SINIEF 25/12, efeitos a partir de 20.12.12)</infAdProd></det><det nItem="3"><prod><cProd>FRASCANMI000022</cProd><cEAN>7898208485896</cEAN><xProd>CORTES CONGELADOS DE FRANGO (COXINHA DA ASA IQF) PACOTE 800G CX PP 9,6 KG (CANCAO)</xProd><NCM>02071400</NCM><CEST>1708700</CEST><cBenef></cBenef><CFOP>5102</CFOP><uCom>KG</uCom><qCom>28.8000</qCom><vUnCom>10.98993056</vUnCom><vProd>316.51</vProd><cEANTrib>17898208485893</cEANTrib><uTrib>KG</uTrib><qTrib>28.8000</qTrib><vUnTrib>10.98993056</vUnTrib><indTot>1</indTot></prod><imposto><ICMS><ICMS20><orig>0</orig><CST>20</CST><modBC>3</modBC><pRedBC>41.6700</pRedBC><vBC>184.62</vBC><pICMS>12.0000</pICMS><vICMS>22.16</vICMS><vICMSDeson>15.83</vICMSDeson><motDesICMS>9</motDesICMS></ICMS20></ICMS><IPI><cEnq>999</cEnq><IPINT><CST>51</CST></IPINT></IPI><PIS><PISNT><CST>06</CST></PISNT></PIS><COFINS><COFINSNT><CST>06</CST></COFINSNT></COFINS></imposto><infAdProd>Valor Dispensado R$ 15.83, Motivo da Desoneracao do ICMS: 9.(Ajuste SINIEF 25/12, efeitos a partir de 20.12.12)</infAdProd></det><det nItem="4"><prod><cProd>FRPTCANMI000024</cProd><cEAN>7898208485957</cEAN><xProd>CORTES CONGELADOS DE FRANGO (FILEZINHO SASSAMI IQF) PACOTE 800G CX PP 9,6 KG (CANCAO)</xProd><NCM>02071400</NCM><CEST>1708700</CEST><cBenef></cBenef><CFOP>5102</CFOP><uCom>KG</uCom><qCom>28.8000</qCom><vUnCom>12.43993056</vUnCom><vProd>358.27</vProd><cEANTrib>17898208485954</cEANTrib><uTrib>KG</uTrib><qTrib>28.8000</qTrib><vUnTrib>12.43993056</vUnTrib><indTot>1</indTot></prod><imposto><ICMS><ICMS20><orig>0</orig><CST>20</CST><modBC>3</modBC><pRedBC>41.6700</pRedBC><vBC>208.98</vBC><pICMS>12.0000</pICMS><vICMS>25.07</vICMS><vICMSDeson>17.91</vICMSDeson><motDesICMS>9</motDesICMS></ICMS20></ICMS><IPI><cEnq>999</cEnq><IPINT><CST>51</CST></IPINT></IPI><PIS><PISNT><CST>06</CST></PISNT></PIS><COFINS><COFINSNT><CST>06</CST></COFINSNT></COFINS></imposto><infAdProd>Valor Dispensado R$ 17.91, Motivo da Desoneracao do ICMS: 9.(Ajuste SINIEF 25/12, efeitos a partir de 20.12.12)</infAdProd></det><total><ICMSTot><vBC>1215.53</vBC><vICMS>145.86</vICMS><vICMSDeson>104.20</vICMSDeson><vFCPUFDest>0</vFCPUFDest><vICMSUFDest>0</vICMSUFDest><vICMSUFRemet>0</vICMSUFRemet><vFCP>0</vFCP><vBCST>0</vBCST><vST>0</vST><vFCPST>0</vFCPST><vFCPSTRet>0</vFCPSTRet><vProd>2083.88</vProd><vFrete>0</vFrete><vSeg>0</vSeg><vDesc>0</vDesc><vII>0</vII><vIPI>0</vIPI><vIPIDevol>0</vIPIDevol><vPIS>0</vPIS><vCOFINS>0</vCOFINS><vOutro>0</vOutro><vNF>2083.88</vNF></ICMSTot></total><transp><modFrete>0</modFrete><transporta><CNPJ>32901703000187</CNPJ><xNome>CABALA TRANSPORTES LTDA</xNome><IE>258991240</IE><xEnder>R APIUNA, 158</xEnder><xMun>SCHROEDER</xMun><UF>SC</UF></transporta><veicTransp><placa>QJI8584</placa><UF>SC</UF><RNTC>00528658</RNTC></veicTransp><vol><qVol>13</qVol><esp>DIVERSOS</esp><pesoL>187.600</pesoL><pesoB>192.710</pesoB></vol></transp><cobr><fat><nFat>002000032081</nFat><vOrig>2083.88</vOrig><vDesc>0</vDesc><vLiq>2083.88</vLiq></fat><dup><nDup>001</nDup><dVenc>2023-05-11</dVenc><vDup>2083.88</vDup></dup></cobr><pag><detPag><indPag>1</indPag><tPag>15</tPag><vPag>2083.88</vPag></detPag></pag><infAdic><infAdFisco>REDUCAO DE BASE DE CALCULO PREVISTA NO ANEXO VI DO RICMS/PR DECRETO 7.871/2017, ESPECIFICADO NA TAG CBENF DO XML. PIS E COFINS TRIBUTADO A ALIQUOTA ZERO CONF LEI N 10.925/2004 ART 1 ITEM V.</infAdFisco><infCpl>Motorista: 000674 - CRISTIANO CORREA 00.511.058.9-69-   Veiculo: QJI8584 - 3/4 LEVE Para Denuncias, Criticas e Sugestoes utilize o Canal Aberto da GTFoods - 0800 645 0945 / denuncia@gtfoods.com.br Valor do ICMS Desonerado: R$ 104,20.</infCpl></infAdic><infRespTec><CNPJ>53113791000122</CNPJ><xContato>Rodrigo de Almeida Sartorio</xContato><email>resp_tecnico_dfe_protheus@totvs.com.br</email><fone>1128593904</fone></infRespTec></infNFe><Signature xmlns="http://www.w3.org/2000/09/xmldsig#"><SignedInfo xmlns="http://www.w3.org/2000/09/xmldsig#"><CanonicalizationMethod Algorithm="http://www.w3.org/TR/2001/REC-xml-c14n-20010315"></CanonicalizationMethod><SignatureMethod Algorithm="http://www.w3.org/2000/09/xmldsig#rsa-sha1"></SignatureMethod><Reference URI="#NFe42230485070068001090550020000320811571552860"><Transforms><Transform Algorithm="http://www.w3.org/2000/09/xmldsig#enveloped-signature"></Transform><Transform Algorithm="http://www.w3.org/TR/2001/REC-xml-c14n-20010315"></Transform></Transforms><DigestMethod Algorithm="http://www.w3.org/2000/09/xmldsig#sha1"></DigestMethod><DigestValue>C6gBvdG/bX5MEON2CLiBbg4aQTQ=</DigestValue></Reference></SignedInfo><SignatureValue>SWwDTM0hogo8cEJzKFCoNydFlWgBB72GwTrmmHUx96/RuTsbJfMSm1CbK5yyV71yME7ojY3zaT6/GZcH9/iKHLrgqJn0lMcu8qZd/pK/XiEwgjZcVp5Qw2Mnq4aSWnXAwFxG4vJQ/v9ZkI/itNVNvAXEewHDjzC1LUezSJQ3sy4A2qD1+/9QvavvEMHTJTk8NHP6bM9D6mJtGjYOxkxGuOwV+P7weepYRsug679d3VM8Jaqh0sw57aWA1Fs7gvlZbWLd240TWcQTG+PSqBxfgnjFo8SqFXLbjW/2qxDCW2bOxW6b1Rm3hWx4O/pUqh14Wdqb0iVjeAxQ/HXYQc4X5g==</SignatureValue><KeyInfo><X509Data><X509Certificate>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</X509Certificate></X509Data></KeyInfo></Signature></NFe><protNFe xmlns="http://www.portalfiscal.inf.br/nfe" versao="4.00"><infProt><tpAmb>1</tpAmb><verAplic>SVRS202303091530</verAplic><chNFe>42230485070068001090550020000320811571552860</chNFe><dhRecbto>2023-04-20T04:17:32-03:00</dhRecbto><nProt>342230086782379</nProt><digVal>C6gBvdG/bX5MEON2CLiBbg4aQTQ=</digVal><cStat>100</cStat><xMotivo>Autorizado o uso da NF-e</xMotivo></infProt></protNFe></nfeProc>`;

    const xml3 = `<?xml version="1.0" encoding="UTF-8"?><nfeProc xmlns="http://www.portalfiscal.inf.br/nfe" versao="4.00"><NFe xmlns="http://www.portalfiscal.inf.br/nfe"><infNFe Id="NFe42230485070068001090550020000322031152485912" versao="4.00"><ide><cUF>42</cUF><cNF>15248591</cNF><natOp>VDA MERC ADQ TERC</natOp><mod>55</mod><serie>2</serie><nNF>32203</nNF><dhEmi>2023-04-25T03:40:00-03:00</dhEmi><dhSaiEnt>2023-04-25T03:40:00-03:00</dhSaiEnt><tpNF>1</tpNF><idDest>1</idDest><cMunFG>4208203</cMunFG><tpImp>1</tpImp><tpEmis>1</tpEmis><cDV>2</cDV><tpAmb>1</tpAmb><finNFe>1</finNFe><indFinal>0</indFinal><indPres>0</indPres><procEmi>0</procEmi><verProc>12.1.033 | 3.0</verProc></ide><emit><CNPJ>85070068001090</CNPJ><xNome>Goncalves e Tortola SA - (FL 01016)</xNome><xFant>GTFOODS ITAJAI FILIAL DE VENDA</xFant><enderEmit><xLgr>Rodovia Jorge Lacerda</xLgr><nro>SN</nro><xBairro>Salseiros</xBairro><cMun>4208203</cMun><xMun>ITAJAI</xMun><UF>SC</UF><CEP>88311605</CEP><cPais>1058</cPais><xPais>BRASIL</xPais></enderEmit><IE>255383533</IE><CRT>3</CRT></emit><dest><CNPJ>10203903000123</CNPJ><xNome>SUPERMERCADO JOSIANE CAMPOS LTDA</xNome><enderDest><xLgr>RODOVIA BR 101 KM 25 TERREO</xLgr><nro>SN</nro><xBairro>RIO BONITO PIRABEIRA</xBairro><cMun>4209102</cMun><xMun>JOINVILLE</xMun><UF>SC</UF><CEP>89239501</CEP><cPais>1058</cPais><xPais>BRASIL</xPais><fone>4738013651</fone></enderDest><indIEDest>1</indIEDest><IE>255655568</IE><email>joanedecampos@yahoo.com.br;faturamento@alinetto.com.br</email></dest><det nItem="1"><prod><cProd>FRCSMIFMI000001</cProd><cEAN>7897200602188</cEAN><xProd>CORTES CONGELADOS DE FRANGO (COXA E SOBRECOXA INDIVID) CX PP 18 KG MISTER FRANGO</xProd><NCM>02071400</NCM><CEST>1708700</CEST><cBenef></cBenef><CFOP>5102</CFOP><uCom>KG</uCom><qCom>900.0000</qCom><vUnCom>6.40000000</vUnCom><vProd>5760.00</vProd><cEANTrib>17897200602185</cEANTrib><uTrib>KG</uTrib><qTrib>900.0000</qTrib><vUnTrib>6.40000000</vUnTrib><indTot>1</indTot></prod><imposto><ICMS><ICMS20><orig>0</orig><CST>20</CST><modBC>3</modBC><pRedBC>41.6700</pRedBC><vBC>3359.81</vBC><pICMS>12.0000</pICMS><vICMS>403.18</vICMS><vICMSDeson>288.02</vICMSDeson><motDesICMS>9</motDesICMS></ICMS20></ICMS><IPI><cEnq>999</cEnq><IPINT><CST>51</CST></IPINT></IPI><PIS><PISNT><CST>06</CST></PISNT></PIS><COFINS><COFINSNT><CST>06</CST></COFINSNT></COFINS></imposto><infAdProd>Valor Dispensado R$ 288.02, Motivo da Desoneracao do ICMS: 9.(Ajuste SINIEF 25/12, efeitos a partir de 20.12.12)</infAdProd></det><total><ICMSTot><vBC>3359.81</vBC><vICMS>403.18</vICMS><vICMSDeson>288.02</vICMSDeson><vFCPUFDest>0</vFCPUFDest><vICMSUFDest>0</vICMSUFDest><vICMSUFRemet>0</vICMSUFRemet><vFCP>0</vFCP><vBCST>0</vBCST><vST>0</vST><vFCPST>0</vFCPST><vFCPSTRet>0</vFCPSTRet><vProd>5760.00</vProd><vFrete>0</vFrete><vSeg>0</vSeg><vDesc>0</vDesc><vII>0</vII><vIPI>0</vIPI><vIPIDevol>0</vIPIDevol><vPIS>0</vPIS><vCOFINS>0</vCOFINS><vOutro>0</vOutro><vNF>5760.00</vNF></ICMSTot></total><transp><modFrete>0</modFrete><transporta><CNPJ>08944671000112</CNPJ><xNome>ALINETTO TRANSPORTES LTDA</xNome><IE>255434910</IE><xEnder>R DOM PEDRO</xEnder><xMun>SCHROEDER</xMun><UF>SC</UF></transporta><veicTransp><placa>QJI8584</placa><UF>SC</UF><RNTC>00528658</RNTC></veicTransp><vol><qVol>50</qVol><esp>DIVERSOS</esp><pesoL>900.000</pesoL><pesoB>917.100</pesoB></vol></transp><cobr><fat><nFat>002000032203</nFat><vOrig>5760.00</vOrig><vDesc>0</vDesc><vLiq>5760.00</vLiq></fat><dup><nDup>001</nDup><dVenc>2023-05-14</dVenc><vDup>5760.00</vDup></dup></cobr><pag><detPag><indPag>1</indPag><tPag>15</tPag><vPag>5760.00</vPag></detPag></pag><infAdic><infAdFisco>REDUCAO DE BASE DE CALCULO PREVISTA NO ANEXO VI DO RICMS/PR DECRETO 7.871/2017, ESPECIFICADO NA TAG CBENF DO XML. PIS E COFINS TRIBUTADO A ALIQUOTA ZERO CONF LEI N 10.925/2004 ART 1 ITEM V.</infAdFisco><infCpl>Motorista: 000674 - CRISTIANO CORREA 00.511.058.9-69-   Veiculo: QJI8584 - 3/4 LEVE Para Denuncias, Criticas e Sugestoes utilize o Canal Aberto da GTFoods - 0800 645 0945 / denuncia@gtfoods.com.br Valor do ICMS Desonerado: R$ 288,02.</infCpl></infAdic><infRespTec><CNPJ>53113791000122</CNPJ><xContato>Rodrigo de Almeida Sartorio</xContato><email>resp_tecnico_dfe_protheus@totvs.com.br</email><fone>1128593904</fone></infRespTec></infNFe><Signature xmlns="http://www.w3.org/2000/09/xmldsig#"><SignedInfo xmlns="http://www.w3.org/2000/09/xmldsig#"><CanonicalizationMethod Algorithm="http://www.w3.org/TR/2001/REC-xml-c14n-20010315"></CanonicalizationMethod><SignatureMethod Algorithm="http://www.w3.org/2000/09/xmldsig#rsa-sha1"></SignatureMethod><Reference URI="#NFe42230485070068001090550020000322031152485912"><Transforms><Transform Algorithm="http://www.w3.org/2000/09/xmldsig#enveloped-signature"></Transform><Transform Algorithm="http://www.w3.org/TR/2001/REC-xml-c14n-20010315"></Transform></Transforms><DigestMethod Algorithm="http://www.w3.org/2000/09/xmldsig#sha1"></DigestMethod><DigestValue>QBmEkZcmAryLSr+KIAqz0pjusXc=</DigestValue></Reference></SignedInfo><SignatureValue>NP+9nDaUWhqQx+2fPd43bnibeMJtoTsi/avHHK10LJHC8mh2wHRT2MxIKvKQ01wwBycuWDwM+TKixjz2AjvlGknRlP+dA7I3lGn5UDBh9XZmTuccrLNpt8Y2c2CwSQQAxr5i5rpU9z05lL7lyXjPsZ/j3mCGtN3NH5KTtLsCfihF421GV/F7Ned6bD3L8Zst0aKYxOYFKlK5H2I4pxgKjvJUXyz86AwO1o/imIl9qdPZOtU6CzGRQjBw/0SrnAKwWVDDJ3LKcBzSJ7rKEME1hvLq0waSBxq+HCcWnXZqf4tTZ7pt/AovHWnuOKQY05EdU1pBDKMewAKNgpXPPPr8aw==</SignatureValue><KeyInfo><X509Data><X509Certificate>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</X509Certificate></X509Data></KeyInfo></Signature></NFe><protNFe xmlns="http://www.portalfiscal.inf.br/nfe" versao="4.00"><infProt><tpAmb>1</tpAmb><verAplic>SVRS202303091530</verAplic><chNFe>42230485070068001090550020000322031152485912</chNFe><dhRecbto>2023-04-25T03:43:59-03:00</dhRecbto><nProt>342230089642024</nProt><digVal>QBmEkZcmAryLSr+KIAqz0pjusXc=</digVal><cStat>100</cStat><xMotivo>Autorizado o uso da NF-e</xMotivo></infProt></protNFe></nfeProc>`;

    const xml = `<?xml version="1.0" encoding="UTF-8"?><nfeProc xmlns="http://www.portalfiscal.inf.br/nfe" versao="4.00"><NFe xmlns="http://www.portalfiscal.inf.br/nfe"><infNFe Id="NFe42230585070068001090550020000326511990169825" versao="4.00"><ide><cUF>42</cUF><cNF>99016982</cNF><natOp>VDA MERC ADQ TERC</natOp><mod>55</mod><serie>2</serie><nNF>32651</nNF><dhEmi>2023-05-04T04:19:00-03:00</dhEmi><dhSaiEnt>2023-05-04T04:19:00-03:00</dhSaiEnt><tpNF>1</tpNF><idDest>1</idDest><cMunFG>4208203</cMunFG><tpImp>1</tpImp><tpEmis>1</tpEmis><cDV>5</cDV><tpAmb>1</tpAmb><finNFe>1</finNFe><indFinal>0</indFinal><indPres>0</indPres><procEmi>0</procEmi><verProc>12.1.033 | 3.0</verProc></ide><emit><CNPJ>85070068001090</CNPJ><xNome>Goncalves e Tortola SA - (FL 01016)</xNome><xFant>GTFOODS ITAJAI FILIAL DE VENDA</xFant><enderEmit><xLgr>Rodovia Jorge Lacerda</xLgr><nro>SN</nro><xBairro>Salseiros</xBairro><cMun>4208203</cMun><xMun>ITAJAI</xMun><UF>SC</UF><CEP>88311605</CEP><cPais>1058</cPais><xPais>BRASIL</xPais></enderEmit><IE>255383533</IE><CRT>3</CRT></emit><dest><CNPJ>18978524000389</CNPJ><xNome>JUCILMAR JOSE ELI &amp; FILHOS SUPERMERCADO LTDA</xNome><enderDest><xLgr>AV PAULO ROBERTO VIDAL</xLgr><nro>SN</nro><xBairro>LOTEAMENTO PARQUE VALE VERDE</xBairro><cMun>4211900</cMun><xMun>PALHOCA</xMun><UF>SC</UF><CEP>88132599</CEP><cPais>1058</cPais><xPais>BRASIL</xPais><fone>4734000500</fone></enderDest><indIEDest>1</indIEDest><IE>261259121</IE><email>FINANCEIRO@CONTABILIDADEVINHOLI.COM.BR;faturamento@alinetto.</email></dest><det nItem="1"><prod><cProd>COMPRO000005</cProd><cEAN>7898208484301</cEAN><xProd>PAO DE QUEIJO TRADICIONAL CONGELADO 20 G PACOTE 1 KG CX PP 12 KG (CANCAO)</xProd><NCM>19012000</NCM><CEST>1704605</CEST><cBenef></cBenef><CFOP>5102</CFOP><uCom>KG</uCom><qCom>24.0000</qCom><vUnCom>11.10000000</vUnCom><vProd>266.40</vProd><cEANTrib>17898208484308</cEANTrib><uTrib>KG</uTrib><qTrib>24.0000</qTrib><vUnTrib>11.10000000</vUnTrib><indTot>1</indTot></prod><imposto><ICMS><ICMS00><orig>0</orig><CST>00</CST><modBC>3</modBC><vBC>266.40</vBC><pICMS>12.0000</pICMS><vICMS>31.97</vICMS></ICMS00></ICMS><IPI><cEnq>999</cEnq><IPINT><CST>51</CST></IPINT></IPI><PIS><PISAliq><CST>01</CST><vBC>234.43</vBC><pPIS>1.6500</pPIS><vPIS>3.87</vPIS></PISAliq></PIS><COFINS><COFINSAliq><CST>01</CST><vBC>234.43</vBC><pCOFINS>7.6000</pCOFINS><vCOFINS>17.82</vCOFINS></COFINSAliq></COFINS></imposto></det><det nItem="2"><prod><cProd>COMPRO000007</cProd><cEAN>7898208484295</cEAN><xProd>PAO DE QUEIJO TRADICIONAL CONGELADO 20 G PACOTE 300 G CX PP 12 KG (CANCAO)</xProd><NCM>19012000</NCM><CEST>1704605</CEST><cBenef></cBenef><CFOP>5102</CFOP><uCom>KG</uCom><qCom>12.0000</qCom><vUnCom>12.00000000</vUnCom><vProd>144.00</vProd><cEANTrib>17898208484292</cEANTrib><uTrib>KG</uTrib><qTrib>12.0000</qTrib><vUnTrib>12.00000000</vUnTrib><indTot>1</indTot></prod><imposto><ICMS><ICMS00><orig>0</orig><CST>00</CST><modBC>3</modBC><vBC>144.00</vBC><pICMS>12.0000</pICMS><vICMS>17.28</vICMS></ICMS00></ICMS><IPI><cEnq>999</cEnq><IPINT><CST>51</CST></IPINT></IPI><PIS><PISAliq><CST>01</CST><vBC>126.72</vBC><pPIS>1.6500</pPIS><vPIS>2.09</vPIS></PISAliq></PIS><COFINS><COFINSAliq><CST>01</CST><vBC>126.72</vBC><pCOFINS>7.6000</pCOFINS><vCOFINS>9.63</vCOFINS></COFINSAliq></COFINS></imposto></det><det nItem="3"><prod><cProd>FRCSMIFMI000001</cProd><cEAN>7897200602188</cEAN><xProd>CORTES CONGELADOS DE FRANGO (COXA E SOBRECOXA INDIVID) CX PP 18 KG MISTER FRANGO</xProd><NCM>02071400</NCM><CEST>1708700</CEST><cBenef></cBenef><CFOP>5102</CFOP><uCom>KG</uCom><qCom>540.0000</qCom><vUnCom>6.69000000</vUnCom><vProd>3612.60</vProd><cEANTrib>17897200602185</cEANTrib><uTrib>KG</uTrib><qTrib>540.0000</qTrib><vUnTrib>6.69000000</vUnTrib><indTot>1</indTot></prod><imposto><ICMS><ICMS20><orig>0</orig><CST>20</CST><modBC>3</modBC><pRedBC>41.6700</pRedBC><vBC>2107.23</vBC><pICMS>12.0000</pICMS><vICMS>252.87</vICMS><vICMSDeson>180.64</vICMSDeson><motDesICMS>9</motDesICMS></ICMS20></ICMS><IPI><cEnq>999</cEnq><IPINT><CST>51</CST></IPINT></IPI><PIS><PISNT><CST>06</CST></PISNT></PIS><COFINS><COFINSNT><CST>06</CST></COFINSNT></COFINS></imposto><infAdProd>Valor Dispensado R$ 180.64, Motivo da Desoneracao do ICMS: 9.(Ajuste SINIEF 25/12, efeitos a partir de 20.12.12)</infAdProd></det><det nItem="4"><prod><cProd>FRMDMIFMI000006</cProd><cEAN>7897200607114</cEAN><xProd>CORTES CONGELADO DE FRANGO (CORACAO PACOTE) CX PP 18 KG MISTER FRANGO</xProd><NCM>02071400</NCM><CEST>1708700</CEST><cBenef></cBenef><CFOP>5102</CFOP><uCom>KG</uCom><qCom>90.0000</qCom><vUnCom>19.85000000</vUnCom><vProd>1786.50</vProd><cEANTrib>17897200607111</cEANTrib><uTrib>KG</uTrib><qTrib>90.0000</qTrib><vUnTrib>19.85000000</vUnTrib><indTot>1</indTot></prod><imposto><ICMS><ICMS20><orig>0</orig><CST>20</CST><modBC>3</modBC><pRedBC>41.6700</pRedBC><vBC>1042.07</vBC><pICMS>12.0000</pICMS><vICMS>125.04</vICMS><vICMSDeson>89.33</vICMSDeson><motDesICMS>9</motDesICMS></ICMS20></ICMS><IPI><cEnq>999</cEnq><IPINT><CST>51</CST></IPINT></IPI><PIS><PISNT><CST>06</CST></PISNT></PIS><COFINS><COFINSNT><CST>06</CST></COFINSNT></COFINS></imposto><infAdProd>Valor Dispensado R$ 89.33, Motivo da Desoneracao do ICMS: 9.(Ajuste SINIEF 25/12, efeitos a partir de 20.12.12)</infAdProd></det><det nItem="5"><prod><cProd>COMPRO000059</cProd><cEAN>7898208483731</cEAN><xProd>POLENTA PALITO TRADICIONAL CONGELADA PACOTE 1 KG CX PP 10 KG PROD. CANCAO</xProd><NCM>19019090</NCM><CEST>1704615</CEST><cBenef></cBenef><CFOP>5102</CFOP><uCom>KG</uCom><qCom>10.0000</qCom><vUnCom>9.00000000</vUnCom><vProd>90.00</vProd><cEANTrib>17898208483738</cEANTrib><uTrib>KG</uTrib><qTrib>10.0000</qTrib><vUnTrib>9.00000000</vUnTrib><indTot>1</indTot></prod><imposto><ICMS><ICMS00><orig>0</orig><CST>00</CST><modBC>3</modBC><vBC>90.00</vBC><pICMS>12.0000</pICMS><vICMS>10.80</vICMS></ICMS00></ICMS><IPI><cEnq>999</cEnq><IPINT><CST>51</CST></IPINT></IPI><PIS><PISAliq><CST>01</CST><vBC>79.20</vBC><pPIS>1.6500</pPIS><vPIS>1.31</vPIS></PISAliq></PIS><COFINS><COFINSAliq><CST>01</CST><vBC>79.20</vBC><pCOFINS>7.6000</pCOFINS><vCOFINS>6.02</vCOFINS></COFINSAliq></COFINS></imposto></det><total><ICMSTot><vBC>3649.70</vBC><vICMS>437.96</vICMS><vICMSDeson>269.97</vICMSDeson><vFCPUFDest>0</vFCPUFDest><vICMSUFDest>0</vICMSUFDest><vICMSUFRemet>0</vICMSUFRemet><vFCP>0</vFCP><vBCST>0</vBCST><vST>0</vST><vFCPST>0</vFCPST><vFCPSTRet>0</vFCPSTRet><vProd>5899.50</vProd><vFrete>0</vFrete><vSeg>0</vSeg><vDesc>0</vDesc><vII>0</vII><vIPI>0</vIPI><vIPIDevol>0</vIPIDevol><vPIS>7.27</vPIS><vCOFINS>33.47</vCOFINS><vOutro>0</vOutro><vNF>5899.50</vNF></ICMSTot></total><transp><modFrete>0</modFrete><transporta><CNPJ>32901703000187</CNPJ><xNome>CABALA TRANSPORTES LTDA</xNome><IE>258991240</IE><xEnder>R APIUNA, 158</xEnder><xMun>SCHROEDER</xMun><UF>SC</UF></transporta><veicTransp><placa>QJI8584</placa><UF>SC</UF><RNTC>00528658</RNTC></veicTransp><vol><qVol>39</qVol><esp>DIVERSOS</esp><pesoL>676.000</pesoL><pesoB>689.200</pesoB></vol></transp><cobr><fat><nFat>002000032651</nFat><vOrig>5899.50</vOrig><vDesc>0</vDesc><vLiq>5899.50</vLiq></fat><dup><nDup>001</nDup><dVenc>2023-05-23</dVenc><vDup>5899.50</vDup></dup></cobr><pag><detPag><indPag>1</indPag><tPag>15</tPag><vPag>5899.50</vPag></detPag></pag><infAdic><infAdFisco>REDUCAO DE BASE DE CALCULO PREVISTA NO ANEXO VI DO RICMS/PR DECRETO 7.871/2017, ESPECIFICADO NA TAG CBENF DO XML. PIS E COFINS TRIBUTADO A ALIQUOTA ZERO CONF LEI N 10.925/2004 ART 1 ITEM V.</infAdFisco><infCpl>Motorista: 000674 - CRISTIANO CORREA 00.511.058.9-69-   Veiculo: QJI8584 - 3/4 LEVE Para Denuncias, Criticas e Sugestoes utilize o Canal Aberto da GTFoods - 0800 645 0945 / denuncia@gtfoods.com.br Valor do ICMS Desonerado: R$ 269,97.</infCpl></infAdic><infRespTec><CNPJ>53113791000122</CNPJ><xContato>Rodrigo de Almeida Sartorio</xContato><email>resp_tecnico_dfe_protheus@totvs.com.br</email><fone>1128593904</fone></infRespTec></infNFe><Signature xmlns="http://www.w3.org/2000/09/xmldsig#"><SignedInfo xmlns="http://www.w3.org/2000/09/xmldsig#"><CanonicalizationMethod Algorithm="http://www.w3.org/TR/2001/REC-xml-c14n-20010315"></CanonicalizationMethod><SignatureMethod Algorithm="http://www.w3.org/2000/09/xmldsig#rsa-sha1"></SignatureMethod><Reference URI="#NFe42230585070068001090550020000326511990169825"><Transforms><Transform Algorithm="http://www.w3.org/2000/09/xmldsig#enveloped-signature"></Transform><Transform Algorithm="http://www.w3.org/TR/2001/REC-xml-c14n-20010315"></Transform></Transforms><DigestMethod Algorithm="http://www.w3.org/2000/09/xmldsig#sha1"></DigestMethod><DigestValue>p0SwcFeWoOBuKktXSV9gsXUMu60=</DigestValue></Reference></SignedInfo><SignatureValue>kkVXUl5ihnOG/iPwn6Kl3SoUHpP31b6bXFQwIdi05t6WVkICKq9L37SRhMNfrXoZM1KSSoiEUM60WgbuHsDyaLAbjT//0xUKpMyrxUmW+x8m8XBUn0UQIvNozbWw+yhKbwOpWs4d+QIslFHVUr8Dbr9DA1buJkSH8UW3jCKsinx7sAxnZcGK7BUEy1fyTbh/GclA6uAOiC58YRmTanu7lHCPwVHUyHE1y4B8XXr8+WawHE77LULuEmVfcTfRuo5hjohlRlcol4FYX5BTPcNQuXv2NszLBm6tK9JHjGLsLllGD/t6UiBxPpIhoL4ykdTm91/EDz8cBCmT3mlGQyyegw==</SignatureValue><KeyInfo><X509Data><X509Certificate>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</X509Certificate></X509Data></KeyInfo></Signature></NFe><protNFe xmlns="http://www.portalfiscal.inf.br/nfe" versao="4.00"><infProt><tpAmb>1</tpAmb><verAplic>SVRS202304261131</verAplic><chNFe>42230585070068001090550020000326511990169825</chNFe><dhRecbto>2023-05-04T04:22:19-03:00</dhRecbto><nProt>342230097399880</nProt><digVal>p0SwcFeWoOBuKktXSV9gsXUMu60=</digVal><cStat>100</cStat><xMotivo>Autorizado o uso da NF-e</xMotivo></infProt></protNFe></nfeProc>`;

    let data = {
      origem:
        "Erwino Menegotti, numero 1320, Chico de Paulo, Jaraguá do Sul, SC, 89254-000",
      destino:
        "Erwino Menegotti, numero 1320, Chico de Paulo, Jaraguá do Sul, SC, 89254-000",
      destino3: "Rua 1136, Barra do Rio Cerro, Jaraguá do Sul, SC, 89260-285",
      destino2: "Paulino Pretti, numero 88, Jaraguá do Sul, SC",
      pontos2: [
        { local: "Barra Velha, SC", parada: true },
        { local: "Massaranduba, SC", parada: true },
        { local: "Joinville, SC", parada: true },
        { local: "Piçarras, SC", parada: true },
        { local: "Penha, SC", parada: true },
        { local: "Camboriu, SC", parada: true },
        { local: "Porto Belo, SC", parada: true },
        { local: "Roman Haffemann, numero 108, Guaramirim, SC", parada: true },
      ],
      pontos: [],
    };

    let listaXmls = [];

    if (listaXmlPreDefinidas === null) {
      listaXmls.push(xml2);
      listaXmls.push(xml);
      listaXmls.push(xml3);
    } else {
      listaXmls = listaXmlPreDefinidas;
    }

    await axios
      .post(
        `${this.props.getBaseUrlRoteirizador()}/converter-xml-json`,
        { listaXmls },
        this.props.parameters()
      )
      .then(async (response) => {
        let listaXmlFormatada = response.data.lista;

        let listaXml = [];

        console.log(JSON.stringify(listaXmlFormatada));

        //  return false;

        for (let xmlParse of listaXmlFormatada) {
          let teste88 = Object.assign({}, xmlParse);
          delete teste88.xml;

          console.log("nnnnn", teste88.produtos);

          data.pontos.push({
            local: `${xmlParse.rua}, ${xmlParse.numero}, ${xmlParse.bairro}, ${xmlParse.cidade}, ${xmlParse.estado}, ${xmlParse.cep}`,
            parada: true,
          });

          listaXml.push({
            xml: xmlParse.xml,
            nome: xmlParse.nome,
            cnpj: xmlParse.cnpj,
            telefone: xmlParse.telefone,
            endereco: `${xmlParse.rua}, ${xmlParse.numero}, ${xmlParse.bairro}, ${xmlParse.cidade}, ${xmlParse.estado}, ${xmlParse.cep}`,
            felipezika: true,
            enderecoCompleto: {
              rua: xmlParse.rua,
              numero: xmlParse.numero,
              bairro: xmlParse.bairro,
              cidade: xmlParse.cidade,
              estado: xmlParse.estado,
              cep: xmlParse.cep,
            },
            produtos: xmlParse.produtos,
            dadosNota: xmlParse.dadosNota,
          });
        }

        await axios //aqui ele chama o roteirizador, entao so chama uma vez mesmo
          .post(
            `${this.props.getBaseUrlRoteirizador()}/atualizar-rotas`,
            { data },
            this.props.parameters()
          )
          .then((response) => {
            this.iframeRef.current.src = this.iframeRef.current.src;
          });

        this.setState({
          listaXml,
        });
      });

    //  return false;
  }

  notificar(type, message) {
    toast[type](message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }

  handleClickDeletar(id) {
    this.setState({ idXmlDeletar: id, modal: true });
  }

  toggle() {
    this.setState({ modal: !this.state.modal });
  }

  async handleClickConfirmaDeletar() {
    let id = this.state.idXmlDeletar;

    let listaXml = this.state.lista;

    listaXml = listaXml.filter((it) => it._id !== id);

    let novaLista = [];

    for (let item of listaXml) {
      if (item.xml !== null) {
        novaLista.push(item.xml);
      }
    }

    this.toggle();
    this.felipe(novaLista);
    this.notificar("success", "Xml excluído com sucesso!");

    // await axios
    //   .delete(
    //     `${this.props.getBaseUrlApi()}/retaguarda/despesas/${
    //       this.state.despesaDeletar
    //     }`,
    //     this.props.parameters()
    //   )
    //   .then((response) => {
    //     this.setState({ despesaDeletar: null, modal: false }, () => {
    //       this.loadDespesas();
    //       this.notificar("success", "Despesa deletada com sucesso!");
    //     });
    //   })
    //   .catch((error) => {
    //     this.setState({ despesaDeletar: null, modal: false }, () => {
    //       this.notificar("warning", error.response.data.erro);
    //     });
    //   });
  }

  async onClickVisualizarDanfe(xml) {
    await axios
      .post(
        `${this.props.getBaseUrlRoteirizador()}/atualizar-danfe`,
        { xml },
        this.props.parameters()
      )
      .then((response) => {
        window.open(
          `${this.props.getBaseUrlRoteirizador()}/visualizador-danfe.html`,
          "_blank"
        );
      })
      .catch((error) => {
        this.notificar("warning", error.response.data.erro);
      });
  }

  getLetraAlfabeto(index) {
    // index = index + 1;
    const alfabeto = [
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z",
    ];

    return alfabeto[index];
  }

  handleFileChange = (e) => {
    // const selectedFiles = Array.from(e.target.files);
    const selectedFiles = Array.from(e);

    const xmlFiles = selectedFiles.filter((file) => file.type === "text/xml");

    const readerPromises = xmlFiles.map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
          const xmlString = event.target.result;
          resolve(xmlString);
        };
        reader.onerror = (error) => {
          reject(error);
        };
        reader.readAsText(file);
      });
    });

    Promise.all(readerPromises)
      .then((results) => {
        if (this.state.listaXml.length > 0) {
          results = results.concat(this.state.listaXml.map((it) => it.xml));
        }

        this.felipe(results);
      })
      .catch((error) => {
        console.error("Error reading file:", error);
      });
  };

  async loadVeiculos() {
    await axios
      .get(
        `${this.props.getBaseUrlApi()}/retaguarda/veiculos`,
        this.props.parameters()
      )
      .then((response) => {
        console.log(response.data.veiculos);

        let veiculos = response.data.veiculos;
        veiculos = veiculos.map((it) => {
          it.value = it._id;
          it.label = it.desc;
          return it;
        });

        this.setState({ veiculos });
      });
  }

  async loadMotoristas() {
    await axios
      .get(
        `${this.props.getBaseUrlApi()}/retaguarda/usuarios`,
        this.props.parameters()
      )
      .then((response) => {
        console.log("lililll", response.data);

        let motoristas = response.data.usuarios;
        motoristas = motoristas.map((it) => {
          it.value = it._id;
          it.label = it.desc;
          return it;
        });

        this.setState({ motoristas });
      });
  }

  toggle2() {
    this.setState({ modal2: !this.state.modal2 });
  }

  async handleClickSalvarRoteiro() {
    let nomeRoteiro = this.state.nomeRoteiro;
    let veiculoSelecionado = this.state.veiculoSelecionado;
    let motoristaSelecionado = this.state.motoristaSelecionado;
    let data = this.state.data;

    console.log("ffefef", JSON.stringify(this.state));

    console.log("ffefef", this.state);

    //return false;

    if (nomeRoteiro === "") {
      this.notificar("warning", "Favor informar um nome para o roteiro!");
      return false;
    }
    if (veiculoSelecionado === null) {
      this.notificar("warning", "Favor selecionar um veículo!");
      return false;
    }
    if (motoristaSelecionado === null) {
      this.notificar("warning", "Favor selecionar um motorista!");
      return false;
    }

    console.log(this.state.lista);

    //return false;

    let docNovoRoteiro = {
      type: "roteiro",
      tipo: "sequencial",
      cod: this.state.codigo,
      desc: nomeRoteiro,
      status: "pendente",
      dtGravacao: new Date(),
      dtPrevisao: data,
      motorista: {
        _id: motoristaSelecionado._id,
        desc: motoristaSelecionado.desc,
      },
      veiculo: {
        _id: veiculoSelecionado._id,
        desc: veiculoSelecionado.desc,
        placa: veiculoSelecionado.placa,
      },
      visitas: [],
    };

    let sequenciaVisita = 1;

    let lista = this.state.lista;
    let visita = null;

    for (let item2 of lista) {
      if (item2.exibirCobrar) {
        console.log("hhhhhhhhhhhhhhh", item2.produtos);
        console.log("hhhhhhhhhhhhhhh2222", item2.dadosNota);

        visita = {
          codVisita: `${sequenciaVisita}${new Date().getTime().toString()}`,
          seq: sequenciaVisita,
          operacao: "entregar",
          status: "pendente",
          dtEntrega: data,
          obsEntrega: "",
          duracao: "",
          cliente: {
            _id: Math.random().toString().split(".")[1],
            desc: item2.cliente,
            cnpj: item2.cnpj,
            obs: "",
          },
          endereco: {
            end: item2.enderecoCompleto.rua,
            num: item2.enderecoCompleto.numero,
            compl: "",
            bairro: item2.enderecoCompleto.bairro,
            cidade: item2.enderecoCompleto.cidade,
            uf: item2.enderecoCompleto.estado,
            cep: item2.enderecoCompleto.cep,
            coordenadas: {
              lat: item2.coordenadas.lat.toString(),
              long: item2.coordenadas.lng.toString(),
            },
          },
          documentos: [],
          cobranca: {
            cobrar: item2.cobrar,
            valorCobrar: 100,
            recebidoDin: 0,
            recebidoChe: 0,
            recebidoCar: 0,
          },
          recebedor: {
            nome: "",
            cpf: "",
            assinatura: "",
            coordenadas: null,
          },
          canhoto: {
            foto: "",
            valido: false,
          },
          ocorrencias: [],
          volumes: [],
          naoConformidades: [],
        };
        sequenciaVisita = sequenciaVisita + 1;

        console.log("xxxxxxxxxxxxxxxxxxxxxxxx", visita);

        ///aqui adiciona produtos
        let seqItem = 1;

        for (let itemNota of item2.produtos) {
          visita.volumes.push({
            seq: seqItem,
            cod: itemNota.cod,
            desc: itemNota.desc,
            qtd: itemNota.qtd,
            status: itemNota.status,
          });

          seqItem = seqItem + 1;
        }

        ///aqui adiciona produtos

        //aqui adiciona os dados da nota

        visita.documentos.push({
          nro: item2.dadosNota.numeroNf,
          tipo: "nfe",
          valor: item2.dadosNota.valorTotalNota,
          dtEmissao: item2.dadosNota.dtEmissao,
          volumes: item2.produtos.length,
          obs: "",
          danfe: "http://www.google.com",
        });

        //aqui adiciona os dados da nota

        visita.dadosXml = {
          dadosNota: item2.dadosNota,
          xml: item2.xml,
        };

        docNovoRoteiro.visitas.push(visita);
      }
    }

    console.log("aaa", JSON.stringify(docNovoRoteiro));

    // return false;

    this.notificar("success", "Roteiro cadastrado com sucesso!");
    this.toggle2();

    await axios
      .post(
        `${this.props.getBaseUrlApi()}/retaguarda/cadastrar-roteiro`,
        { doc: docNovoRoteiro },
        this.props.parameters()
      )
      .then((response) => {});

    this.atualizaSequenciaRoteiro();

    await axios
      .post(
        `${this.props.getBaseUrlRoteirizador()}/limpar-rotas`,
        {},
        this.props.parameters()
      )
      .then((response) => {});
    window.location.reload();
  }

  handleChangeNomeRoteiro(e) {
    this.setState({ nomeRoteiro: e.target.value });
  }

  handleChangeNomeTemplate(e) {
    this.setState({ descTemplateNovo: e.target.value });
  }

  handleChangeCobrar(id, isChecked) {
    let lista = this.state.lista;
    for (let item of lista) {
      if (item._id === id) {
        item.cobrar = isChecked;
      }
    }

    this.setState({ lista });
  }

  async loadSequenciaRoteiro() {
    await axios
      .get(
        `${this.props.getBaseUrlApi()}/retaguarda/sequencia-roteiro`,
        this.props.parameters()
      )
      .then((response) => {
        let codigo = response.data.codigo;
        codigo = codigo.toString().padStart(4, "0");
        //alert(codigo);
        this.setState({ codigo });
      });
  }

  async atualizaSequenciaRoteiro() {
    await axios
      .post(
        `${this.props.getBaseUrlApi()}/retaguarda/atualiza-sequencia-roteiro`,
        {},
        this.props.parameters()
      )
      .then((response) => {});
  }

  toggleModalXml() {
    this.setState({ modalXml: !this.state.modalXml });
  }

  async loadXmlsBanco() {
    let lista = [];
    await axios
      .get(
        `${this.props.getBaseUrlApi()}/retaguarda/xmls-banco`,
        this.props.parameters()
      )
      .then((response) => {
        let lista = response.data.xmls;
        //////console.clear();
        console.log("aaaaa", lista);
        lista = lista.map((it) => {
          it.selecionado = false;
          return it;
        });
        lista = lista.filter((it) => it.status === "A");
        this.setState({ xmlsBanco: lista });
      });
  }

  handleClickCheckbox(isSelecionado, idXml) {
    let listaXml = this.state.xmlsBanco;

    for (let item of listaXml) {
      if (item._id === idXml) {
        item.selecionado = isSelecionado;
      }
    }

    this.setState({ xmlsBanco: listaXml });
  }

  handleClickImportarXml() {
    let lista = this.state.xmlsBanco;
    lista = lista.filter((it) => it.selecionado);
    lista = lista.map((it) => it.xml);

    if (this.state.listaXml.length > 0) {
      lista = lista.concat(this.state.listaXml.map((it) => it.xml));
    }

    this.felipe(lista);
    this.toggleModalXml();
    this.notificar("success", "Xmls importados para o roteirizador!");
  }

  async loadXmlsTemplateRoteiro(idTemplate) {
    this.setState({ idTemplate }, async () => {
      await axios
        .post(
          `${this.props.getBaseUrlApi()}/retaguarda/roteiros-template`,
          { idTemplate },
          this.props.parameters()
        )
        .then((response) => {
          this.felipe(response.data.xmls);
          this.setState({ descTemplate: response.data.descTemplate });
        });
    });
  }

  async handleSalvarTemplate() {
    let desc = this.state.descTemplateNovo;
    let lista = this.state.lista;

    let clientes = [];

    for (let item2 of lista) {
      if (item2.exibirCobrar) {
        clientes.push({
          desc: item2.cliente,
          cnpj: item2.cnpj,
        });
      }
    }

    let doc = {
      desc,
      type: "template-roteiro",
      status: "A",
      tipo: "cliente",
      clientes,
      dtGravacao: new Date(),
    };

    await axios
      .post(
        `${this.props.getBaseUrlApi()}/retaguarda/cadastrar-template`,
        { doc },
        this.props.parameters()
      )
      .then((response) => {
        this.toggle3();
        return this.props.history.push("/templates-roteiro");
      });
  }

  toggle3() {
    this.setState({ modal3: !this.state.modal3 });
  }

  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />

        <div className="container-scroller font-app">
          <NavBar
            title={`Roteirizador ${
              this.state.descTemplate !== ""
                ? "- " + this.state.descTemplate
                : ""
            }`}
          />
          <div className="container-fluid page-body-wrapper">
            <SideBar itemActive={"roteirizador"} />
            <div className="main-panel">
              <div className="content-wrapper">
                <div className="row">
                  <div className="col-md-2 stretch-card d-flex flex-wrap">
                    {/* <input
                      type="file"
                      multiple
                      onChange={this.handleFileChange}
                      accept=".xml"
                      style={{
                        backgroundColor: "#e0e0e0",
                        color: "#fff",
                        padding: "10px 20px",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer"
                      }}
                    /> */}

                    <DropFileInput
                      onFileChange={(files) => this.handleFileChange(files)}
                    />

                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        position: "relative",
                        top: "-15px",
                      }}
                    >
                      <div style={{ width: "100%" }}>
                        <label className="font-size-14">Veículo</label>
                        <Select
                          value={this.state.veiculoSelecionado}
                          onChange={(veiculoSelecionado) =>
                            this.setState({ veiculoSelecionado })
                          }
                          options={this.state.veiculos}
                          placeholder="Selecione"
                          //   style={{fontSize:"10px"}}
                          styles={{
                            control: (baseStyles, state) => ({
                              ...baseStyles,
                              fontSize: "14px",
                              height: "35px",
                              minHeight: "35px"
                            }),
                            menu: (baseStyles, state) => ({
                              ...baseStyles,
                              fontSize: "14px",
                            }),
                          }}
                          // isDisabled={
                          //   this.state.status !== "pendente" ? true : false
                          // }
                        />
                      </div>
                      <div style={{ width: "100%" }}>
                        <label className="font-size-14">Motorista</label>
                        <Select
                          value={this.state.motoristaSelecionado}
                          onChange={(motoristaSelecionado) =>
                            this.setState({ motoristaSelecionado })
                          }
                          options={this.state.motoristas}
                          placeholder="Selecione"
                          styles={{
                            control: (baseStyles, state) => ({
                              ...baseStyles,
                              fontSize: "14px",
                              height: "35px",
                              minHeight: "35px"
                            }),
                            menu: (baseStyles, state) => ({
                              ...baseStyles,
                              fontSize: "14px",
                            }),
                          }}

                          // isDisabled={
                          //   this.state.status !== "pendente" ? true : false
                          // }
                        />
                      </div>
                      <div style={{ width: "100%" }}>
                        <label className="font-size-14">Data</label>
                        <DatePicker
                          selected={this.state.data}
                          withPortal
                          customInput={
                            <input className="form-control font-size-14 form-control-chegoo" />
                          }
                          dateFormat="dd/MM/yyyy"
                          onChange={(date) => {
                            this.setState({ data: date });
                          }}
                          locale="pt-BR"
                        />
                      </div>
                      <span
                        onClick={this.toggleModalXml}
                        style={{
                          marginTop: "5px",
                          width: "100%",
                          textAlign: "center",
                          cursor: "pointer",
                          color: "#214a9d",
                          fontWeight: "bold",
                          fontSize:"16px"
                        }}
                      >
                        Importar do banco
                      </span>
                      {/* <span
                        onClick={() => {
                          console.log(this.state);
                        }}
                        style={{
                          marginTop: "5px",
                          width: "100%",
                          textAlign: "center",
                          cursor: "pointer",
                          color: "#214a9d",
                          fontWeight: "bold",
                        }}
                      >
                        felipe
                      </span> */}
                      {/* <div>
                        <
                        <button
                          onClick={() => {
                            this.toggleModalXml();
                          }}
                        >
                          felipe3
                        </button>
                      </div> */}
                    </div>
                    {/* <button
                      onClick={() => {
                        this.felipe();
                      }}
                    >
                      felipe
                    </button> */}

                    {/* <button
                      onClick={() => {
                        window.open("http://localhost:5500", "_blank");
                      }}
                    >
                      Abrir mapa
                    </button> */}
                  </div>
                  <div className="col-md-10 stretch-card d-flex flex-wrap">
                    <div style={{ width: "100%" }}>
                      <iframe
                        src={`${this.props.getBaseUrlRoteirizador()}/index.html`}
                        width="100%"
                        height={"350px"}
                        title="description"
                        ref={this.iframeRef}
                      ></iframe>
                    </div>
                    {this.state.lista.length > 0 && (
                      <small
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          window.open(
                            `${this.props.getBaseUrlRoteirizador()}`,
                            "_blank"
                          );
                        }}
                      >
                        Abrir em tela cheia
                      </small>
                    )}
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12 stretch-card">
                    <div className="card" style={{ marginTop: "10px" }}>
                      <div className="card-body2">
                        <div className="table-responsive">
                          <table
                            id="recent-purchases-listing"
                            className="table table-striped"
                          >
                            <thead className="thead-dark">
                              <tr>
                                <th>Endereço</th>
                                <th>Cliente</th>

                                <th className="text-center">Telefone</th>
                                <th className="">Obs</th>
                                <th className="text-center">Distância</th>
                                <th className="text-center">Tempo Previsto</th>
                                <th className="text-center">Cobrar?</th>

                                <th>Ações</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.lista.length > 0 &&
                                this.state.lista.map((item, key) => (
                                  <tr key={key}>
                                    <td
                                      style={
                                        {
                                          //fontWeight: "bold"
                                        }
                                      }
                                    >
                                      <img
                                        src={`data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2026%2037%22%3E%3Cg%20fill%3D%22none%22%3E%3Cpath%20d%3D%22M13%200C5.817%200%200%205.773%200%2012.918c0%207.655%205.59%2010.526%209.555%2017.16C12.09%2034.321%2011.342%2037%2013%2037c1.723%200%20.975-2.743%203.445-6.858C20.085%2023.86%2026%2020.605%2026%2012.918%2026%205.773%2020.183%200%2013%200z%22%20fill%3D%22%23C5221F%22/%3E%3Cpath%20d%3D%22M13.017%2035c-.233%200-.3-.065-.7-1.275-.332-1.046-.832-2.648-2.13-4.61-1.265-1.928-2.596-3.498-3.861-5.002C3.363%2020.517%201%2017.706%201%2012.64%201.033%206.199%206.393%201%2013.017%201S25%206.23%2025%2012.639c0%205.067-2.33%207.911-5.326%2011.507-1.232%201.504-2.53%203.073-3.795%204.97-1.265%201.928-1.797%203.498-2.13%204.544-.4%201.275-.5%201.34-.732%201.34z%22%20fill%3D%22%23EA4335%22/%3E%3Ctext%20text-anchor%3D%22middle%22%20dy%3D%22.3em%22%20x%3D%2213%22%20y%3D%2214%22%20font-family%3D%22Roboto%2C%20Arial%2C%20sans-serif%22%20font-size%3D%2216px%22%20fill%3D%22%23FFF%22%3E${this.getLetraAlfabeto(
                                          key
                                        )}%3C/text%3E%3C/g%3E%3C/svg%3E`}
                                      ></img>
                                      {item.endereco}
                                    </td>
                                    <td>
                                      {" "}
                                      {item.cliente !== ""
                                        ? item.cliente
                                        : " - "}{" "}
                                    </td>
                                    <td className="text-center">
                                      {" "}
                                      {item.telefone !== ""
                                        ? item.telefone
                                        : " - "}{" "}
                                    </td>
                                    <td className=""> </td>
                                    <td className="text-center">
                                      {item.distancia !== null
                                        ? item.distancia
                                        : " - "}
                                    </td>
                                    <td className="text-center">
                                      {item.duracao !== null
                                        ? item.duracao
                                        : " - "}
                                    </td>

                                    <td className="text-center">
                                      {item.exibirCobrar ? (
                                        <input
                                          type="checkbox"
                                          checked={item.cobrar}
                                          onChange={(e) =>
                                            this.handleChangeCobrar(
                                              item._id,
                                              e.target.checked
                                            )
                                          }
                                        ></input>
                                      ) : (
                                        " - "
                                      )}
                                    </td>

                                    <td
                                      className="d-flex"
                                      style={{ fontSize: "18px" }}
                                    >
                                      {item.xml !== null && (
                                        <React.Fragment>
                                          <div
                                            style={{
                                              margin: "3px",
                                              cursor: "pointer",
                                            }}
                                          >
                                            <i
                                              id={`danfe-app-${item._id}`}
                                              className="fa fa-file-pdf-o"
                                              onClick={() => {
                                                if (item.xml !== null) {
                                                  this.onClickVisualizarDanfe(
                                                    item.xml
                                                  );
                                                }
                                              }}
                                              style={{
                                                fontSize: "22px",
                                                color:
                                                  item.xml === null
                                                    ? "inherit"
                                                    : "blue",
                                              }}
                                              // onClick={() => {
                                              //   this.props.history.push(
                                              //     `/despesas-motorista?id=${despesa.idUsuario}`
                                              //   );
                                              // }}
                                            ></i>

                                            <UncontrolledTooltip
                                              placement="right"
                                              target={`danfe-app-${item._id}`}
                                            >
                                              Visualizar Danfe
                                            </UncontrolledTooltip>
                                          </div>
                                          <div
                                            style={{
                                              margin: "3px",
                                              cursor: "pointer",
                                            }}
                                          >
                                            <i
                                              id={`danfe-app2-${item._id}`}
                                              className="fa fa-trash"
                                              onClick={() => {
                                                this.handleClickDeletar(
                                                  item._id
                                                );
                                              }}
                                              style={{
                                                color: "red",
                                                fontSize: "22px",
                                              }}
                                              // onClick={() => {
                                              //   this.props.history.push(
                                              //     `/despesas-motorista?id=${despesa.idUsuario}`
                                              //   );
                                              // }}
                                            ></i>

                                            <UncontrolledTooltip
                                              placement="right"
                                              target={`danfe-app2-${item._id}`}
                                            >
                                              Apagar XML
                                            </UncontrolledTooltip>
                                          </div>
                                        </React.Fragment>
                                      )}
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                        {this.state.lista.length > 0 && (
                          <div style={{ display: "flex" }}>
                            <div style={{ margin: "3px" }}>
                              <button
                                className="btn btn-success btn-app-verde"
                                onClick={() => {
                                  this.toggle2();
                                }}
                              >
                                SALVAR ROTEIRO
                              </button>
                            </div>
                            {this.state.idTemplate === null && (
                              <div style={{ margin: "3px" }}>
                                <button
                                  className="btn btn-secondary font-size-14"
                                  onClick={() => {
                                    this.toggle3();
                                  }}
                                >
                                  SALVAR TEMPLATE
                                </button>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>

        <Modal isOpen={this.state.modal} toggle={this.toggle}>
          <ModalHeader toggle={this.toggle}>Deletar XML</ModalHeader>
          <ModalBody>Tem certeza que deseja deletar este XML?</ModalBody>
          <ModalFooter>
            <Button
              className="btn-modal-recuperar"
              color="secondary"
              onClick={this.toggle}
            >
              Não
            </Button>
            <Button
              className="btn-modal-recuperar"
              color="primary"
              onClick={this.handleClickConfirmaDeletar}
            >
              Sim
            </Button>{" "}
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modal2} toggle={this.toggle2}>
          <ModalHeader toggle={this.toggle2}>Salvar Roteiro</ModalHeader>
          <ModalBody>
            <div className="form-group form-group-chegoo">
              <label>Nome do Roteiro</label>
              <input
                type="text"
                className="form-control form-control-chegoo font-size-14"
                value={this.state.nomeRoteiro}
                onChange={(e) => this.handleChangeNomeRoteiro(e)}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              className="btn-modal-recuperar"
              color="secondary"
              onClick={this.toggle2}
            >
              Cancelar
            </Button>
            <Button
              className="btn-modal-recuperar"
              color="primary"
              onClick={this.handleClickSalvarRoteiro}
            >
              Salvar
            </Button>{" "}
          </ModalFooter>
        </Modal>
        <Modal
          isOpen={this.state.modalXml}
          toggle={this.toggleModalXml}
          className="modal-dialog-app"
        >
          <ModalHeader toggle={this.toggleModalXml}>
            Xmls cadastrados
          </ModalHeader>
          <ModalBody>
            <div className="table-responsive">
              <table
                id="recent-purchases-listing"
                className="table table-striped"
              >
                <thead className="thead-dark">
                  <tr>
                    <th>Nfe</th>
                    <th className="text-center">Data</th>
                    <th>Cliente</th>
                    <th>Valor Nfe</th>
                    <th className="text-center">Seleciona?</th>

                    {/* <th>Ações</th> */}
                  </tr>
                </thead>
                <tbody>
                  {this.state.xmlsBanco.length > 0 &&
                    this.state.xmlsBanco.map((item, key) => (
                      <tr key={key}>
                        <td>{item.numeroNota}</td>
                        <td className="text-center">
                          {" "}
                          {moment(item.dtEmissao).format("DD/MM/YY")}{" "}
                        </td>
                        <td> {item.cliente.desc} </td>
                        <td> R$ {formatarReal(item.valorTotalNota)} </td>
                        <td className="text-center">
                          <input
                            type="checkbox"
                            checked={item.selecionado}
                            onChange={(e) => {
                              this.handleClickCheckbox(
                                e.target.checked,
                                item._id
                              );
                            }}
                          />{" "}
                        </td>

                        {/* <td className="d-flex" style={{ fontSize: "18px" }}>
                          {item.xml !== null && (
                            <React.Fragment>
                              <div
                                style={{
                                  margin: "3px",
                                  cursor: "pointer",
                                }}
                              >
                                <i
                                  id={`danfe-app-${item._id}`}
                                  className="fa fa-file-pdf-o"
                                  onClick={() => {
                                    if (item.xml !== null) {
                                      this.onClickVisualizarDanfe(item.xml);
                                    }
                                  }}
                                  style={{
                                    fontSize: "22px",
                                    color:
                                      item.xml === null ? "inherit" : "blue",
                                  }}
                                  // onClick={() => {
                                  //   this.props.history.push(
                                  //     `/despesas-motorista?id=${despesa.idUsuario}`
                                  //   );
                                  // }}
                                ></i>

                                <UncontrolledTooltip
                                  placement="right"
                                  target={`danfe-app-${item._id}`}
                                >
                                  Visualizar Danfe
                                </UncontrolledTooltip>
                              </div>
                              <div
                                style={{
                                  margin: "3px",
                                  cursor: "pointer",
                                }}
                              >
                                <i
                                  id={`danfe-app2-${item._id}`}
                                  className="fa fa-trash"
                                  onClick={() => {
                                    this.handleClickDeletar(item._id);
                                  }}
                                  style={{
                                    color: "red",
                                    fontSize: "22px",
                                  }}
                                  // onClick={() => {
                                  //   this.props.history.push(
                                  //     `/despesas-motorista?id=${despesa.idUsuario}`
                                  //   );
                                  // }}
                                ></i>

                                <UncontrolledTooltip
                                  placement="right"
                                  target={`danfe-app2-${item._id}`}
                                >
                                  Apagar XML
                                </UncontrolledTooltip>
                              </div>
                            </React.Fragment>
                          )}
                        </td> */}
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              className="btn-modal-recuperar"
              color="secondary"
              onClick={this.toggleModalXml}
            >
              Cancelar
            </Button>
            <Button
              className="btn-modal-recuperar"
              color="primary"
              onClick={this.handleClickImportarXml}
              disabled={
                this.state.xmlsBanco.filter((it) => it.selecionado).length === 0
              }
            >
              Importar
            </Button>{" "}
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.modal3} toggle={this.toggle3}>
          <ModalHeader toggle={this.toggle3}>
            Salvar Template de Roteiro
          </ModalHeader>
          <ModalBody>
            <div className="form-group form-group-chegoo">
              <label>Nome do Template</label>
              <input
                type="text"
                className="form-control form-control-chegoo font-size-14"
                value={this.state.descTemplateNovo}
                onChange={(e) => this.handleChangeNomeTemplate(e)}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              className="btn-modal-recuperar"
              color="secondary"
              onClick={this.toggle3}
            >
              Cancelar
            </Button>
            <Button
              className="btn-modal-recuperar"
              color="primary"
              onClick={this.handleSalvarTemplate}
            >
              Salvar
            </Button>{" "}
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}

export default Roteirizador;
